import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import { SelectorAccessFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'

type NameWithAvatarProps = {
  name: string
  avatarUrl?: string
}

export const makeAccessOptions = (accesses: SelectorAccessFragment[]) =>
  accesses.map((access) => {
    const name = access.fullName
    const avatar = access.avatar

    return {
      label: name,
      value: access.id,
      component: <NameWithAvatar name={name ?? ''} avatarUrl={buildUrl(avatar)} />,
    }
  })

const NameWithAvatar = ({ name, avatarUrl }: NameWithAvatarProps) => {
  return (
    <Box gap="s8" flexDirection="row" alignItems="center">
      <Avatar label={name} url={avatarUrl} size="s32" />
      <Text.Normal size="300">{name}</Text.Normal>
    </Box>
  )
}
